const CMDS = [
  ["play", "p", "<link/nazwa>", "Odtwarza utwór lub dodaje do kolejki (YouTube, Spotify, SoundCloud, playlisty)"],
  ["search", "find", "<nazwa>", "Pokazuje 10 wyników do wyboru"],
  ["soundcloud", "sc", "<nazwa>", "Wyszukuje na SoundCloud"],
  ["skip", "s, next", "", "Pomija aktualny utwór"],
  ["skipto", "st", "<nr>", "Przeskakuje do utworu w kolejce"],
  ["pause", "", "", "Wstrzymuje odtwarzanie"],
  ["resume", "r", "", "Wznawia odtwarzanie"],
  ["stop", "", "", "Zatrzymuje i czyści kolejkę"],
  ["leave", "dc, disconnect", "", "Rozłącza bota z kanału"],
  ["join", "summon", "", "Dołącza na Twój kanał głosowy"],
  ["loop", "l, repeat", "[off|track|queue]", "Zmienia tryb zapętlania"],
  ["loopqueue", "lq", "", "Włącza/wyłącza pętlę kolejki"],
  ["queue", "q", "[strona]", "Wyświetla kolejkę"],
  ["nowplaying", "np", "", "Szczegóły aktualnego utworu"],
  ["remove", "rm", "<nr>", "Usuwa utwór z kolejki"],
  ["move", "m", "<z> <do>", "Przenosi utwór w kolejce"],
  ["clear", "cl", "", "Czyści kolejkę"],
  ["shuffle", "random", "", "Miesza kolejkę"],
  ["seek", "", "<czas>", "Przewija do momentu (np. 1:30)"],
  ["replay", "restart", "", "Odtwarza utwór od początku"],
  ["volume", "vol, v", "<0-200>", "Zmienia głośność"],
  ["247", "stay, 24/7", "", "Tryb 24/7 — bot zostaje na kanale i gra bez przerwy (autoplay)"],
  ["ping", "", "", "Pokazuje opóźnienie"],
  ["help", "h", "", "Lista komend"],
];

export default function CommandMatrix({ prefix = "!" }) {
  return (
    <section className="card p-5 sm:p-6 fade-up" data-testid="command-matrix">
      <div className="flex items-end justify-between flex-wrap gap-2">
        <div>
          <div className="caption">Komendy · prefiks {prefix}</div>
          <h2 className="font-heading text-2xl font-bold tracking-tight mt-1">Wszystkie komendy SikeSound</h2>
        </div>
        <span className="text-xs text-slate-500">Aliasy działają zamiennie, wielkość liter bez znaczenia</span>
      </div>
      <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {CMDS.map(([c, a, args, d]) => (
          <div key={c} className="rounded-lg border border-slate-800 bg-slate-950/40 px-3 py-2.5 hover:border-emerald-500/40 transition-colors" data-testid={`command-${c}`}>
            <div className="font-mono text-sm">
              <span className="text-emerald-400">{prefix}{c}</span> <span className="text-slate-500">{args}</span>
            </div>
            <div className="text-xs text-slate-400 mt-1">{d}</div>
            {a && <div className="text-[10px] font-mono text-indigo-300/80 mt-1">alias: {a}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
